import React, { useState, useEffect } from 'react';
import axios from 'axios';
import DocumentManager from '../components/DocumentManager';
import './DocumentsPage.css';

const API_URL = '/api';

export default function DocumentsPage({ phases, tasks, onReload }) {
  const [documents, setDocuments] = useState([]);
  const [filter, setFilter] = useState({ phaseId: '', taskId: '' });

  useEffect(() => {
    loadAll();
  }, []);

  const loadAll = async () => {
    try {
      const res = await axios.get(`${API_URL}/documents`);
      setDocuments(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="documents-page">
      <h2>📁 Documents</h2>
      <div className="card">
        <h3>Ajouter / Gérer</h3>
        <div style={{marginBottom:12}}>
          <label>Uploader un document lié à une phase ou une tâche</label>
        </div>
        <DocumentManager phaseId={filter.phaseId || null} taskId={filter.taskId || null} />
      </div>

      <div className="card">
        <h3>Liste des documents</h3>
        <div className="filters">
          <select value={filter.phaseId} onChange={e => setFilter({...filter, phaseId: e.target.value})}>
            <option value="">— Filtrer par phase —</option>
            {phases.map(p => <option key={p.id} value={p.id}>{p.nom}</option>)}
          </select>
          <select value={filter.taskId} onChange={e => setFilter({...filter, taskId: e.target.value})}>
            <option value="">— Filtrer par tâche —</option>
            {tasks.map(t => <option key={t.id} value={t.id}>{t.title}</option>)}
          </select>
        </div>

        <div className="documents-list">
          {documents
            .filter(d => (filter.phaseId ? d.phase_id == filter.phaseId : true) && (filter.taskId ? d.task_id == filter.taskId : true))
            .map(doc => (
              <div className="doc-row" key={doc.id}>
                <div className="doc-left">
                  <strong>{doc.name || doc.original_name}</strong>
                  <div className="muted">{doc.description || ''}</div>
                </div>
                <div className="doc-right muted">{doc.file_size ? `${(doc.file_size/1024).toFixed(1)} KB` : ''} • {new Date(doc.created_at).toLocaleDateString()}</div>
                <div className="doc-actions">
                  <a className="btn" href={`/api/documents/download/${doc.id}`} target="_blank" rel="noreferrer">Télécharger</a>
                </div>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
}
